<template>
    <transition name="fade">
        <div class="cookie-consent-container" v-if="isVisible">
            <div class="cookie-consent">
                <div v-if="showHeader" class="cookie-consent-header" data-nosnippet>
                    Cookie Settings
                </div>
                <div class="cookie-consent-body">
                    <div class="cookie-consent-text" data-nosnippet v-html="policyText"></div>
                    <div class="cookie-consent-actions" data-nosnippet>
                        <a class="button btn-gray opt-out" @click="reject()">Opt Out</a>
                        <a class="button btn-orange accept" @click="accept()">Accept</a>
                    </div>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        props: {
            showHeader: {
                type: Boolean,
                default: false
            },
            isCookieStatusSet: {
                type: Boolean,
                default: false,
            },
            domain: {
                type: String,
                default: null,
            },
            policyText: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                isVisible: false,
            }
        },
        methods: {
            accept() {
                this.setCookie('analytics', 'enabled')
                window.dataLayer.push({'event': 'analytics-accepted'});
                this.hide()
            },
            reject() {
                this.setCookie('analytics', 'disabled')
                this.hide()
            },
            setCookie(name, value, domain) {
                let cookie = "cookieconsent_" + name + "_status=" + value + "; expires=" + this.nextYear + "; path=/;";

                if (this.domain) {
                    cookie = cookie + " domain=" + this.domain;
                }

                document.cookie = cookie
            },
            show() {
                this.isVisible = true
            },
            hide() {
                this.isVisible = false
            },
        },
        computed: {
            nextYear() {
                const date = new Date()
                const nextFullYear = date.getFullYear() + 1

                date.setFullYear(nextFullYear)

                return date.toUTCString()
            },
        },
        mounted() {
            if (!this.isCookieStatusSet) {
                this.show()
            }
        }
    }
</script>

<!--suppress CssInvalidAtRule -->
<style lang="scss">
    .cookie-consent-container {
        @apply fixed left-0 bottom-0 flex max-w-screen-sm;
        .cookie-consent {
            @apply m-4 bg-white border border-solid border-gray-300 text-gray-300;
            .cookie-consent-header {
                @apply font-bold bg-gray-300 text-gray-900 px-4 py-2;

            }

            .cookie-consent-body {
                @apply p-4;
                .cookie-consent-text {
                    @apply mb-8;
                    a {
                        @apply underline text-orange;
                    }
                }

                .cookie-consent-actions {
                    @apply flex justify-between;
                    @screen md {
                        @apply justify-start;
                    }
                    .button {
                        @apply mx-2;
                        &.opt-out {
                            &:hover {
                                @apply bg-white border-gray-900;
                            }
                        }

                        &:first-child {
                            @apply ml-0;
                        }

                        &:last-child {
                            @apply mr-0;
                        }
                    }
                }
            }
        }

    }
</style>